"use strict";
exports.__esModule = true;
var EnvelopeChartLogic = /** @class */ (function () {
    function EnvelopeChartLogic() {
    }
    EnvelopeChartLogic.downloadCsv = function (selectedGraph, filename, csvFormat, skipSave) {
        var csv = 'Node name : ' + selectedGraph.nodeName + '\n';
        csv = this.makeCSV(selectedGraph.mainRows, csv);
        if (selectedGraph.siblingNodeName) {
            csv += '\nCompareTo Node name : ' + selectedGraph.siblingNodeName + '\n';
            csv = this.makeCSV(selectedGraph.siblingRows, csv);
        }
        if (csvFormat == 'EU') {
            csv = csv.replace(/,/g, ';');
            csv = csv.replace(/\./g, ',');
        }
        if (!skipSave) {
            var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
            saveAs(blob, filename);
        }
        return csv;
    };
    EnvelopeChartLogic.makeCSV = function (rows, csv) {
        rows.unshift(['', 'Low', 'Base', 'High']);
        var _loop_1 = function (i) {
            rows.forEach(function (row) {
                csv += row[i] + ',';
            });
            csv += '\n';
        };
        for (var i = 0; i < 4; i++) {
            _loop_1(i);
        }
        return csv;
    };
    EnvelopeChartLogic.calculateTenFiftyNinety = function (fittedPoints) {
        var summary = {};
        for (var i = 0; i < fittedPoints.length; i++) {
            var prob = fittedPoints[i][1];
            var val = fittedPoints[i][0];
            if ((i == 0 && prob > 0.1) || (prob == 0.1)) {
                summary['Low'] = val;
            }
            else if (i > 0 && fittedPoints[i - 1][1] < 0.1 && prob > 0.1) {
                summary['Low'] = this.calculatePoint(fittedPoints[i - 1][1], fittedPoints[i - 1][0], prob, val, 0.1);
            }
            if (prob == 0.5) {
                summary['Base'] = val;
            }
            else if (i > 0 && fittedPoints[i - 1][1] < 0.5 && prob > 0.5) {
                summary['Base'] = this.calculatePoint(fittedPoints[i - 1][1], fittedPoints[i - 1][0], prob, val, 0.5);
            }
            if ((i == fittedPoints.length - 1 && prob < 0.9) || (prob == 0.9)) {
                summary['High'] = val;
            }
            else if (i > 0 && fittedPoints[i - 1][1] < 0.9 && prob > 0.9) {
                summary['High'] = this.calculatePoint(fittedPoints[i - 1][1], fittedPoints[i - 1][0], prob, val, 0.9);
            }
        }
        return summary;
    };
    EnvelopeChartLogic.calculatePoint = function (prevProb, prevVal, prob, val, x) {
        return (((val - prevVal) / (prob - prevProb)) * (x - prevProb)) + prevVal;
    };
    EnvelopeChartLogic.addMissingRow = function (envelopeChartData) {
        var startYear = envelopeChartData[0][0];
        var lastYear = envelopeChartData[envelopeChartData.length - 1][0];
        if (lastYear !== startYear + envelopeChartData.length - 1) {
            for (var i = 0; i < envelopeChartData.length; i++) {
                if (envelopeChartData[i + 1][0] !== envelopeChartData[i][0] + 1) {
                    var missedLow = this.calculatePoint(envelopeChartData[i][0], envelopeChartData[i][1], envelopeChartData[i + 1][0], envelopeChartData[i + 1][1], envelopeChartData[i][0] + 1);
                    var missedBase = this.calculatePoint(envelopeChartData[i][0], envelopeChartData[i][2], envelopeChartData[i + 1][0], envelopeChartData[i + 1][2], envelopeChartData[i][0] + 1);
                    var missedHigh = this.calculatePoint(envelopeChartData[i][0], envelopeChartData[i][3], envelopeChartData[i + 1][0], envelopeChartData[i + 1][3], envelopeChartData[i][0] + 1);
                    var missedRow = [envelopeChartData[i][0] + 1, missedLow, missedBase, missedHigh];
                    envelopeChartData.splice(i + 1, 0, missedRow);
                    this.addMissingRow(envelopeChartData);
                    break;
                }
            }
        }
        return envelopeChartData;
    };
    return EnvelopeChartLogic;
}());
exports.EnvelopeChartLogic = EnvelopeChartLogic;
//# sourceMappingURL=envelope-chart.logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/envelope-chart/envelope-chart.logic.js